<template>
  <div class="sdg" style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255); padding-bottom: 50px" v-if="pay_way">
    <div style="width: 100%; background: #fff">
      <van-nav-bar
        style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7"
        title="存款"
        left-arrow
        @click-left="$router.back()"
      >
        <template #right>
          <span class="record-nav-btn" @click.stop="openDepositRecordPopup">存款记录</span>
        </template>
      </van-nav-bar>
      <div style="height: 46px"></div>
      <!-- 存款方式选择 -->
      <div class="typelis">
        <div :class="pay_way == 'hengli' ? 'tyls atc' : 'tyls'" @click="changPayway('hengli')">
          <img src="/static/image/icoOnlineTransfer2@3x.png" alt="" />
          人民币支付
        </div>
        <div :class="pay_way == 'usdt' ? 'tyls atc' : 'tyls'" @click="changPayway('usdt')" v-if="payWayList.usdt == 1">
          <img src="/static/image/1595237922936176.png" alt="" />
          USDT
        </div>
        <div class="tyls" @click="$parent.openKefu">
          <img src="/static/image/icoOnlineTransfer2@3x.png" alt="" />
          人工充值
        </div>
      </div>
      <div v-if="pay_way == 'bank' && !(userbank.length == 0 && userUSD.length == 0)">
        <div class="usrse">
          <div class="bans" style="" v-for="(item, index) in cardLis" :key="index">
            <p>
              <span class="frists"> 收款账号 </span><span class="sdsw">{{ item.bank_no }}</span
              ><span class="copy" @click="doCopy(item.bank_no)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 银行户名 </span><span class="sdsw">{{ item.bank_owner }}</span
              ><span class="copy" @click="doCopy(item.bank_owner)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 开户行 </span><span class="sdsw">{{ item.bank_data.bank_name }}</span
              ><span class="copy" @click="doCopy(item.bank_data.bank_name)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 银行地址 </span><span class="sdsw">{{ item.bank_address }}</span
              ><span class="copy" @click="doCopy(item.bank_address)"> 复制 </span>
            </p>
          </div>
          <div class="hgs" @click="changShow">
            <div class="nams">开户银行</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank" type="text" placeholder="选择开户银行" disabled> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">存款人姓名</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_owner" type="text" placeholder="请输入存款人姓名"> </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg">为及时到账，请务必输入正确的存款人姓名</div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">银行卡号</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_no" type="text" placeholder="请输入银行卡号"> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">开户行地址</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_address" type="text" placeholder="请输入开户行地址"> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`">
                  <template #button> <span style="color: #000"> 元</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg"></div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        </div>
      </div>
      <div v-if="pay_way == 'usdt'">
        <div class="tipsh">
          <div class="tops">USDT价格稳定 流通性高 不受监管 <span @click="$parent.goNav('/usdtmore')">了解更多 ></span></div>
          <div class="tsg">
            <div class="tsgs">绑定协议地址</div>
            <div class="tsgs">交易所划转</div>
            <div class="tsgs">完成取款</div>
          </div>
        </div>
        <div class="usrse">
          <div class="hgs">
            <div class="nams sc">
              钱包协议
              <div :class="meyXi == 'TRC20' ? ' ssa acti' : 'ssa'" @click="changXiyi('TRC20')">TRC20</div>
              <!-- <div :class="meyXi == 'ERC20' ? ' ssa acti' : 'ssa'" style="margin-left: 0.5rem" @click="changXiyi('ERC20')">ERC20</div> -->
              <a class="wallet-download-btn" href="https://www.promoohivex.com/join/17775903" target="_blank" rel="noopener noreferrer">欧易钱包下载</a>
            </div>
            <div style="border-bottom: 1px solid #f2f2f2"></div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <!-- <div class="hgs">
            <div class="nams">USDT地址</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <div data-v-a12ec382="" class="van-cell-group van-hairline--top-bottom">
                <div data-v-a12ec382="" class="van-cell van-field">
                  <div class="van-cell__value van-cell__value--alone van-field__value">
                    <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" placeholder="请输入USDT地址" class="van-field__control" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div> -->
          <div class="hgs">
            <div class="nams">存款金额（USDT）</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="U" v-model="amount" type="text" :placeholder="`请输入充值USDT数量 ${usdtMin} - ${usdtMax}`">
                  <template #button> <span style="color: #000"> USDT</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg">{{ usdtToRmb }}元 ; 参考汇率：{{ usdtrate.toFixed(2) }}元</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">温馨提示</div>
            <div class="lasthg" style="border-top: 1px solid #eee; margin-top: 10px">请选择正确的USDT协议付款，若您选择错误的协议付款，平台将无法收到您的付款，为此我们不承担任何负责！</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        </div>
      </div>
      <div v-if="pay_way == 'hengli'">
        <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>

        <div class="usrse">
          <div class="hgs">
            <div class="nams">支付通道</div>
            <div class="channel-wrap">
              <div v-for="channel in payChannels" :key="channel.code" :class="selectedPayChannel.code === channel.code ? 'channel-item active' : 'channel-item'" @click="selectPayChannel(channel)">
                <span class="fee-rate">{{ Number(channel.fee_rate || 0) }}%</span>
                <span class="gift-rate" v-if="Number(channel.gift_rate || 0) > 0">赠送{{ Number(channel.gift_rate || 0) }}%</span>
                <img class="channel-icon" :src="channel.icon" alt="" />
                <span>{{ channel.name }}</span>
              </div>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`">
                  <template #button> <span style="color: #000"> 元</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg"></div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        </div>
      </div>
      <div style="margin: 0 auto; width: 86%">
        <van-button type="info" style="margin-top: 20px; width: 100%" @click="payTest">立即存款</van-button>
        <div class="textcns" style="text-align: center; color: #999; padding: 10px 0">存款遇到问题？联系 <span @click="$parent.openKefu" style="color: #cf866b; display: inline-block; margin: 0 6px">人工客服</span> 解决</div>
      </div>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
    <van-popup v-model="depositRecordPopup" position="bottom" :style="{ height: '78%' }" class="record-popup">
      <div class="record-header">
        <div class="record-title">存款记录</div>
        <div class="record-date-filter">
          <span :class="depositRecordDate == 1 ? 'record-date-item active' : 'record-date-item'" @click="changeDepositRecordDate(1)">今日</span>
          <span :class="depositRecordDate == 2 ? 'record-date-item active' : 'record-date-item'" @click="changeDepositRecordDate(2)">近7日</span>
          <span :class="depositRecordDate == 3 ? 'record-date-item active' : 'record-date-item'" @click="changeDepositRecordDate(3)">近15日</span>
          <span :class="depositRecordDate == 4 ? 'record-date-item active' : 'record-date-item'" @click="changeDepositRecordDate(4)">近30日</span>
        </div>
      </div>
      <van-list
        v-if="depositRecordList.length > 0"
        class="record-list"
        finished-text="没有更多了"
        offset="200"
        v-model="depositRecordLoading"
        :finished="depositRecordFinished"
        @load="getDepositRecordList"
      >
        <van-cell v-for="(item, index) in depositRecordList" :key="index">
          <div style="font-size: 0.3rem">订单号：{{ item.out_trade_no }}</div>
          <div style="display: flex; justify-content: space-between; font-size: 0.3rem">
            <div>金额：{{ item.amount }}</div>
            <div>{{ item.pay_way }}</div>
            <div>{{ depositStateType[item.state] || '未定义' }}</div>
          </div>
          <div style="font-size: 0.3rem">{{ item.created_at }}</div>
        </van-cell>
      </van-list>
      <div v-else class="record-empty">
        <img src="/static/image/mescroll-empty.png" style="width: 35%" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px ' }">空空如也</van-divider>
      </div>
    </van-popup>
    <!-- 禁止   -->
    <div class="domainModal_domainView__FWCzg" v-if="userbank.length == 0 && userUSD.length == 0">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="$router.back()"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="$router.back()" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">温馨提示</div>
          <div class="domainModal_middle__3gQPm" style="padding: 30px">您还为绑定任何钱包卡片，请前往绑定！</div>

          <div style="height: 30px; text-align: center; line-height: 30px; color: #fff" @click="$parent.goNav('/wallet')">前往绑定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'recharge',
  computed: {
    usdtrate() {
      // 对齐 PC：存款汇率取 /api/user 下发的 usdtrate
      return Number(this.$store.state.userInfo && this.$store.state.userInfo.usdtrate) || 0;
    },
    usdtMin() {
      if (!this.usdtrate) return '0.00';
      return (this.min_price / this.usdtrate).toFixed(2);
    },
    usdtMax() {
      if (!this.usdtrate) return '0.00';
      return (this.max_price / this.usdtrate).toFixed(2);
    },
    usdtToRmb() {
      if (!this.amount || !this.usdtrate) return '0.00';
      return (Number(this.amount) * this.usdtrate).toFixed(2);
    },
  },
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'TRC20',
      payWayList: {},
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      payChannels: [],
      selectedPayChannel: {},
      depositRecordPopup: false,
      depositRecordDate: 4,
      depositRecordPage: 1,
      depositRecordLoading: false,
      depositRecordFinished: false,
      depositRecordList: [],
      depositRecordPageData: {},
      depositStateType: ['未定义', '待审核', '审核通过', '审核拒绝'],
    };
  },
  created() {
    let that = this;
    that.getPayWay();
    that.getBanklist();
    that.getcard();
  },
  methods: {
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'hengli') {
        type = 'hengli';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type, pay_id: that.selectedPayChannel.id || 0 })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() {
      this.show = !this.show;
    },
    openDepositRecordPopup() {
      this.depositRecordPopup = true;
      this.depositRecordPage = 1;
      this.depositRecordList = [];
      this.depositRecordPageData = {};
      this.depositRecordFinished = false;
      this.getDepositRecordList();
    },
    changeDepositRecordDate(val) {
      if (this.depositRecordDate == val) {
        return;
      }
      this.depositRecordDate = val;
      this.depositRecordPage = 1;
      this.depositRecordList = [];
      this.depositRecordPageData = {};
      this.depositRecordFinished = false;
      this.getDepositRecordList();
    },
    getDepositRecordList() {
      if (this.depositRecordLoading) {
        return;
      }
      const page = this.depositRecordPage;
      if (this.depositRecordPageData.last_page && page > this.depositRecordPageData.last_page) {
        this.depositRecordFinished = true;
        this.depositRecordLoading = false;
        return;
      }
      this.depositRecordLoading = true;
      this.$apiFun
        .post('/api/gettransrecord', { date: this.depositRecordDate, type: 1, page, api_type: '' })
        .then(res => {
          if (res.code != 200) {
            this.showTost(0, res.message);
            return;
          }
          this.depositRecordPageData = res.data || {};
          const data = Array.isArray((res.data || {}).data) ? res.data.data : [];
          if (page == 1) {
            this.depositRecordList = data;
          } else {
            this.depositRecordList = this.depositRecordList.concat(data);
          }
          this.depositRecordPage = page + 1;
          this.depositRecordFinished = this.depositRecordList.length >= Number((this.depositRecordPageData || {}).total || 0);
        })
        .catch(() => {})
        .finally(() => {
          this.depositRecordLoading = false;
        });
    },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    changXiyi(val) {
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.getPayRange();
    },
    selectPayChannel(channel) {
      this.selectedPayChannel = channel;
      this.pay_way = 'hengli';
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            that.initPayChannels();
            if (that.payWayList.usdt == 1) {
              that.pay_way = 'usdt';
              that.getPayRange();
            } else {
              that.changPayway('hengli');
            }
            that.hideLoading();
            return;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};
      let submitAmount = Number(that.amount || 0);

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: submitAmount,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: submitAmount,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
        submitAmount = Number((submitAmount * that.usdtrate).toFixed(2));
        info.amount = submitAmount;
      }
      if (that.pay_way == 'hengli' && that.selectedPayChannel.code) {
        info.pay_id = that.selectedPayChannel.id;
        info.info = `${that.selectedPayChannel.code}|${that.selectedPayChannel.name || ''}`;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (!Number.isFinite(submitAmount) || submitAmount <= 0) {
        that.showTost(0, that.pay_way == 'usdt' ? '请输入正确的USDT数量' : '请输入正确的金额');
        return;
      }
      if (submitAmount < that.min_price || submitAmount > that.max_price) {
        if (that.pay_way == 'usdt') {
          that.showTost(0, `请输入USDT数量在${that.usdtMin}-${that.usdtMax}之间！`);
          return;
        }
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, '提交成功，等待后台审核');
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.bankBox = {};
            that.amount = null;
            const depositNo = encodeURIComponent(res.message || '');
            let query = `deposit_no=${depositNo}`;
            if (that.pay_way == 'hengli' && that.selectedPayChannel.name) {
              query += `&channel_name=${encodeURIComponent(that.selectedPayChannel.name)}`;
            }
            that.$router.push({ path: `/payInfo?${query}` });
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      if (val === 'hengli' && !that.selectedPayChannel.code && that.payChannels.length) {
        that.selectedPayChannel = that.payChannels[0];
      }
      that.getPayRange();
    },
    initPayChannels() {
      this.$apiFun
        .get('/api/get_hengli_pay_list', {})
        .then(res => {
          if (res.code === 200) {
            const source = Array.isArray(res.data) ? res.data : Array.isArray(res.data && res.data.channels) ? res.data.channels : [];
            this.payChannels = source
              .filter(item => Number(item.enabled) === 1)
              .map(item => ({
                ...item,
                id: Number(item.id || 0),
                code: String(item.code || ''),
                name: String(item.name || ''),
                fee_rate: Number(item.fee_rate || 0),
                gift_rate: Number(item.gift_rate || 0),
                icon:
                  String(item.name || '').indexOf('支付宝') > -1
                    ? '/static/image/icoAlipay2@3x.png'
                    : String(item.name || '').indexOf('微信') > -1
                    ? '/static/image/QuickWechat.png'
                    : '/static/image/icoOnlineTransfer2@3x.png',
              }));
            if (!this.selectedPayChannel.code && this.payChannels.length) {
              this.selectedPayChannel = this.payChannels[0];
            }
          }
        })
        .catch(() => {});
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/2d87bbdbffeb4734e5c7.css';

.tipsh {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  background: #f8f8f8;
  box-sizing: border-box;
  padding: 6px;

  .tops {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.4rem;
    font-weight: 700;
    color: #333;
    height: 1rem;
    span {
      font-size: 0.29rem;
      font-weight: 400;
    }
  }
  .tsg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tsgs {
      height: 0.56rem;
      line-height: 0.56rem;
      color: #a5a9b3;
      font-size: 0.2rem;
      text-align: center;
      padding: 4px 8px;
      flex: 1;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA0CAYAAADPCHf8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALCSURBVHgB7d0hcNtAEIXhtWh4y8vDixseXHPz4ibYKW2Kw1UsHt7g8vCWB7u7mYsnss7S3elmam3+b8bjxM6Evaz1tFJWu91uKyLnAixbt1qt7qSyRh+3Aizfpf6xv5TKGk3dX31uBVi+jYak6qehJjx3+ngSYPmuNCTvpZLngOgUsXBU//wG/Adn+thqSM6kgpcJYiG516ffAizfO31cSQXNwfc/BfDhXKfIRmbqBUSniE2QewF8sGZrLTM0kdfsWIQDdnix1pB8lEKDgIQD9k4AP75oSD5IgdgEsZDYeZE/AvhgjVZR/duMvPdDAD+s2fqaW/8eDUg4YKf2hSf2MSur2Wom3mdPC95c5DRbowFhTwtOWbN1kfKDUxPEsKcFjzYpzdZkQNjTglNJzVbKBGFPC15NNltJAQnY04JHo81WckDY04JjR5utnAli2NOCV+vYJbtZAWFPC84Nmq3cCWIsIOxpwavt62YrOyBhirCnBa96l+yWTBD2tODd/pLdlRTShNkv4QQiPOuKJgjwRjzNCcisa32BE/dgFw4WBSRsQiZtQwILZFvs3+2L0gnyWQCfLBzXoa3ND0g4JV/t1o7AibnRcOzP82UFJDRX1e+gDZyIOw3H4+sXcieITY8q9zwFTkyr4RisUSUHJEwPDszh0UO41dVAzgTZCuDPvrGKSQpIqHU5MIc3vcYqZjIg4aMVtS68sVD0GquYlAlirRXTA960h41VzGhAqHXhVLSxipmaIOxbwZvuWGMVczQg7FvBocfc/6U+NkE4MIcn1lh9k0zRgLBvBWessbqeaqxiBgEJB+afBPDjtiQcJjZBmB7wxBqrX1KoFxD2reBMVmMVczhB2LeCF9mNVcw+IOxbwZGixirmOSDsW8GR4sYq5mWCMD3gxU2tcJgmTA9WSuBBG+76WY1NEMIBD9q5jVXMPzyG0oj5jr9QAAAAAElFTkSuQmCC);
      background-size: cover;
    }
  }
}
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding-top: 5px;
  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }
  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;
    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }
    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}
.sc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
  .ssa {
    border-radius: 5px;
    border: 1px solid #f1f1f1;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.4rem;
    font-weight: 700;
    text-align: center;
    margin-left: 1rem;
  }
  .acti {
    color: #cf866b !important;
    border: 1px solid #cf866b !important;
  }
  .wallet-download-btn {
    margin-left: auto;
    color: #fff;
    background: #cf866b;
    border-radius: 5px;
    width: 1.6rem;
    min-height: 0.8rem;
    padding: 0.1rem 0.12rem;
    font-size: 0.24rem;
    text-decoration: none;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: normal;
    word-break: break-all;
  }
}
.typelis {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  .tyls {
    border-radius: 10px;
    border: 1px solid #eee;
    text-align: center;
    width: calc(50% - 0.1rem);
    padding: 0.2rem 0.06rem;
    font-size: 0.26rem;
    box-sizing: border-box;
    line-height: 1.3;
    img {
      width: 0.7rem;
      display: block;
      margin: 0 auto;
      margin-bottom: 0.2rem;
    }
  }
  .tyls.atc {
    border: 1px solid #cf866b;
    color: #cf866b;
  }
}
.lasthg {
  display: flex;
  align-items: center;
  font-size: 0.33rem;
  color: #a5a9b3;
  padding: 0.2rem 0;
}
.channel-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.2rem;
  margin-top: 0.3rem;
}
.channel-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  width: calc((100% - 0.4rem) / 3);
  padding: 0.26rem 0.12rem;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  font-size: 0.32rem;
  color: #333;
  box-sizing: border-box;
}
.gift-rate {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.2rem;
  color: #fff;
  background: #ff4d4f;
  padding: 0.04rem 0.1rem;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.fee-rate {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0.2rem;
  color: #fff;
  background: #fa8c16;
  padding: 0.04rem 0.1rem;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.channel-item.active {
  color: #cf866b;
  border-color: #cf866b;
  background: #fff7f3;
}
.channel-icon {
  width: 0.46rem;
  height: 0.46rem;
  margin-right: 0;
  margin-bottom: 0.12rem;
}

.bans {
  background-image: linear-gradient(180deg, #fff, #f9fcff);
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .frists {
      width: 60px;
    }
    .sdsw {
      flex: 1;
    }
    .copy {
      color: #069b71;
    }
  }
}
.record-popup {
  background: #f7f8fc;
  .record-header {
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 12px;
    .record-title {
      text-align: center;
      font-size: 0.38rem;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .record-date-filter {
      display: flex;
      justify-content: space-between;
      gap: 8px;
      .record-date-item {
        flex: 1;
        text-align: center;
        line-height: 0.7rem;
        border-radius: 0.35rem;
        background: #f6f7fb;
        color: #98a8c5;
        font-size: 0.25rem;
      }
      .record-date-item.active {
        background: #cf866b;
        color: #fff;
      }
    }
  }
  .record-list {
    height: calc(100% - 1.8rem);
    overflow: auto;
    padding-bottom: 20px;
  }
  .record-empty {
    text-align: center;
    margin-top: 60px;
  }
}
.record-nav-btn {
  color: #1989fa;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue